import { render, staticRenderFns } from "./StatusTab.vue?vue&type=template&id=48bb32ee&"
import script from "./StatusTab.vue?vue&type=script&lang=js&"
export * from "./StatusTab.vue?vue&type=script&lang=js&"
import style0 from "./StatusTab.vue?vue&type=style&index=0&id=48bb32ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports